import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import { months_list } from "../../Shared/List"
import AsyncSelectField from "../../Shared/AsyncSelect"

const PayPayrollForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [employeeOptions, setEmployeeOptions] = useState([])
    const [accountOptions, setAccountOptions] = useState([])
    const [title, setTitle] = useState('')

    const [formData, setFormData] = useState({
        employee_id: "",
        account_id: "",
        previous_balance: "",
        debit: 0,
        amount: 0,
        balance: 0,
        remark: "",
        date: new Date().toISOString().slice(0, 10),
        year: "",
        month: "",
    })
    const {employee_id, account_id, previous_balance, debit, amount, balance, remark, date, year, month} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (location.state){
            const {payload} = location.state
            setFormData((prev) => ({
                ...prev,
                year: payload.year,
                month: payload.month
            }))
            setTitle(`${months_list[payload.month - 1].name} - ${payload.year},  Payroll Form`)
        }
    }, [])


    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))

        if (e.target.name === "employee_id"){
            getSalaryDetail(e.target.value)
        }
    }

    const loadOptions = async (url, query, setOptions) => {
        try {
            const params = { q: query, year: formData.year, month: formData.month };

            const response = await Server.get(`/options/${url}`, { params });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const getSalaryDetail = async (employee_id) => {
        const response = await Server.get(`/payrolls/employee-salary-detail?employee_id=${employee_id}&year=${year}&month=${month}`)
        setFormData((prev) => ({
            ...prev,
            previous_balance: parseFloat(response.data.previous_balance).toFixed(2),
            debit: parseFloat(response.data.debit).toFixed(2),
            amount: parseFloat(response.data.credit).toFixed(2),
            balance: parseFloat(response.data.balance).toFixed(2),
        }))

    }

    const AmountKeyUp = (e) => {

        setTimeout(() => {
            setFormData((prevState) => ({
                ...prevState,
                balance: (parseFloat(balance) - parseFloat(e.target.value)).toFixed(2)
            }))
        }, 800)
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {account_id, employee_id, credit: amount, remark, date, year, month}
        // console.log(payload)
        payPayroll(payload)
    }
    
    // add payroll
    const payPayroll = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/payrolls/credit/employee', payload)
            if (response.status === 200){
                toast.success(response.data?.detail)
                setFormData((prev) => ({
                    ...prev,
                    employee_id: "",
                    account_id: "",
                    previous_balance: "",
                    debit: "",
                    amount: "",
                    balance: "",
                    remark: "",
                    date: new Date().toISOString().slice(0, 10),
                }))
                navigate('/pay-payroll', {state: {payload: {year, month}}})
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response?.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="account_id"
                                label="Account"
                                value={account_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('saving-accounts', query, setAccountOptions)}
                                options={accountOptions}
                                placeholder="Start typing to search..."
                                error={errors.account_id}
                            />
                        </div>
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="employee_id"
                                label="Employee"
                                value={employee_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('payroll-employee-balance', query, setEmployeeOptions)}
                                options={employeeOptions}
                                placeholder="Start typing to search..."
                                error={errors.employee_id}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                name="previous_balance"
                                type="number"
                                label="Previous Balance"
                                disabled="disabled"
                                value={parseFloat(previous_balance)}
                                onChange={onChange}
                                error={errors.previous_balance}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                name="debit"
                                type="number"
                                label="Debit"
                                disabled="disabled"
                                value={parseFloat(debit)}
                                onChange={onChange}
                                error={errors.debit}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                name="amount"
                                type="number"
                                label="Credit"
                                value={parseFloat(amount)}
                                onChange={onChange}
                                onKeyUp={AmountKeyUp}
                                error={errors.amount}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                name="balance"
                                type="number"
                                label="Balance"
                                disabled="disabled"
                                value={parseFloat(balance)}
                                onChange={onChange}
                                error={errors.balance}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                placeholder="Date"
                                name="date"
                                type="date"
                                label="Date"
                                value={date}
                                onChange={onChange}
                                error={errors.date}
                            />
                        </div>
                        <div className="col-md-8">
                            <InputField
                                placeholder="Remark (Optinal)"
                                name="remark"
                                type="text"
                                label="Remark"
                                value={remark}
                                onChange={onChange}
                                error={errors.remark}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Process Payment" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default PayPayrollForm